export default {
  title: 'Loyaliteitstablet',
  headers: {
    customer_frequency: 'Klantfrequentie',
  },
};
